import React from 'react'
import Icon from 'app/Components/Icon'
import noImage from './file-no-image.icon.svg'

const NoImageIcon = props => (
	<Icon hint size="2rem" {...props} glyph={noImage} />
)

export default NoImageIcon
